import { Link } from "react-router-dom";
import type { Topic } from "@/types/content";
import SectionHeading from "@/components/feature/SectionHeading";
import { topicArticles } from "@/lib/content";

interface TopicsSectionProps {
  topics: Topic[];
}

export default function TopicsSection({ topics }: TopicsSectionProps) {
  return (
    <section id="topics" aria-label="主题专题合集" className="animate-fade-up">
      <SectionHeading
        eyebrow="Collection · 主题专题"
        title="把相关的内容，放在一起读"
        description="编辑按主题重新组织报道、视频与访谈，形成更完整的观察视角。"
        action={<span className="text-xs text-foreground-400">共 {topics.length} 个专题</span>}
      />
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        {topics.map((topic, index) => {
          const related = topicArticles(topic);
          return (
            <article
              key={topic.id}
              className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative h-44 w-full overflow-hidden bg-background-200 md:h-52">
                <img
                  src={topic.cover}
                  alt={`${topic.title}专题封面`}
                  title={`${topic.title} - 抖阳专题`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/25 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                  <p className="font-label text-[10px] uppercase tracking-[0.22em] text-background-300">
                    Topic 0{index + 1}
                  </p>
                  <h3 className="mt-1 font-heading text-lg font-bold text-background-50 md:text-xl">{topic.title}</h3>
                </div>
                <span className="absolute right-4 top-4 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] text-foreground-700">
                  {related.length} 篇内容
                </span>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-sm leading-relaxed text-foreground-500">{topic.description}</p>
                <ul className="mt-3 space-y-1.5">
                  {related.slice(0, 3).map((article) => (
                    <li key={article.id}>
                      <Link
                        to={`/detail/article/${article.id}`}
                        className="group/link flex items-center gap-2 text-xs text-foreground-700 transition-colors hover:text-primary-600"
                      >
                        <span className="h-1 w-1 shrink-0 rounded-full bg-primary-400" />
                        <span className="truncate">{article.title}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}